import {parseAxiosPromise} from '@/axiosInstance'
import {QUERY_KEYS} from '@/queryClient'
import {captureException} from '@sentry/react'
import {useQuery} from '@tanstack/react-query'
import {httpCommonIssues} from '@features/insights/http/insights.http'
import {CommonIssues} from '../types'
import {getStartDateForPeriod} from '../utils'

export const useGetCommonIssues = (period: 'last_3_month' | 'last_6_month', enabled: boolean) => {
    const {startDate, endDate} = getStartDateForPeriod(period)
    return useQuery({
        queryKey: [QUERY_KEYS.COMMON_ISSUES, period],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpCommonIssues({
                    params: {start_date: startDate, end_date: endDate}
                }),
                responseShape: CommonIssues,
                onZodError: captureException
            }),
        enabled
    })
}
